import React, { useEffect, useState } from 'react';
import { regions, keyInitiatives } from '../utils/mockData';
const CentralMap = ({
  filters
}) => {
  const [activeTab, setActiveTab] = useState('map');
  const [mapLoaded, setMapLoaded] = useState(false);
  const [map, setMap] = useState(null);
  useEffect(() => {
    // We'd normally use Leaflet here, but for simplicity in this demo,
    // we'll just simulate the map loading
    const timer = setTimeout(() => {
      setMapLoaded(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  const getColorForPerformance = performance => {
    if (performance >= 0.8) return '#10b981'; // green
    if (performance >= 0.6) return '#f59e0b'; // amber
    return '#ef4444'; // red
  };
  return <div className="bg-slate-800 rounded-lg p-4 h-full flex flex-col" data-id="element-3">
      <div className="flex justify-between items-center mb-4" data-id="element-4">
        <h2 className="text-xl font-semibold" data-id="element-5">National Performance Overview</h2>
        <div className="flex bg-slate-700 rounded-lg overflow-hidden" data-id="element-6">
          <button className={`px-4 py-2 text-sm ${activeTab === 'map' ? 'bg-blue-600' : ''}`} onClick={() => setActiveTab('map')} data-id="element-7">
            Regional Map
          </button>
          <button className={`px-4 py-2 text-sm ${activeTab === 'initiatives' ? 'bg-blue-600' : ''}`} onClick={() => setActiveTab('initiatives')} data-id="element-8">
            Key Initiatives
          </button>
        </div>
      </div>
      {activeTab === 'map' ? <div className="flex-1 relative" data-id="element-9">
          {!mapLoaded ? <div className="absolute inset-0 flex items-center justify-center" data-id="element-10">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500" data-id="element-11"></div>
            </div> : <div className="w-full h-full bg-slate-700 rounded-lg relative overflow-hidden" data-id="element-12">
              {/* This would be a Leaflet map in a real implementation */}
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-13">
                <svg width="90%" height="90%" viewBox="0 0 1000 800" data-id="element-14">
                  {/* Simplified map of Ethiopia with regions */}
                  {regions.map(region => <g key={region.id} data-id="element-15">
                      {/* We'd use actual GeoJSON shapes in a real implementation */}
                      <circle cx={(region.lng - 34) * 100} cy={800 - (region.lat - 3) * 60} r={25} fill={getColorForPerformance(region.performance)} fillOpacity="0.7" stroke="#fff" strokeWidth="1" data-id="element-16" />
                      <text x={(region.lng - 34) * 100} y={800 - (region.lat - 3) * 60 - 5} textAnchor="middle" fill="white" fontSize="12" data-id="element-17">
                        {region.name.split(' ')[0]}
                      </text>
                      <text x={(region.lng - 34) * 100} y={800 - (region.lat - 3) * 60 + 15} textAnchor="middle" fill="white" fontSize="10" opacity="0.8" data-id="element-18">
                        ETB {(region.performance * 1000).toFixed(0)}M
                      </text>
                    </g>)}
                </svg>
              </div>
              <div className="absolute bottom-4 right-4 bg-slate-800 bg-opacity-80 p-3 rounded-lg" data-id="element-19">
                <h3 className="text-sm font-semibold mb-2" data-id="element-20">
                  Performance Legend
                </h3>
                <div className="flex items-center gap-2 text-xs" data-id="element-21">
                  <span className="w-3 h-3 bg-green-500 rounded-full" data-id="element-22"></span>
                  <span data-id="element-23">High (80%+)</span>
                </div>
                <div className="flex items-center gap-2 text-xs" data-id="element-24">
                  <span className="w-3 h-3 bg-yellow-500 rounded-full" data-id="element-25"></span>
                  <span data-id="element-26">Medium (60-80%)</span>
                </div>
                <div className="flex items-center gap-2 text-xs" data-id="element-27">
                  <span className="w-3 h-3 bg-red-500 rounded-full" data-id="element-28"></span>
                  <span data-id="element-29">Needs Attention (&lt;60%)</span>
                </div>
              </div>
            </div>}
        </div> : <div className="flex-1 grid grid-cols-2 gap-4" data-id="element-30">
          {keyInitiatives.map((initiative, index) => <div key={index} className="bg-slate-700 p-4 rounded-lg" data-id="element-31">
              <h3 className="font-semibold mb-2" data-id="element-32">{initiative.name}</h3>
              <div className="mb-2 text-sm" data-id="element-33">{initiative.impact}</div>
              <div className="flex justify-between text-xs mb-1" data-id="element-34">
                <span data-id="element-35">Progress: {(initiative.progress * 100).toFixed(0)}%</span>
                <span data-id="element-36">
                  {initiative.current.toLocaleString()} /{' '}
                  {initiative.target.toLocaleString()}
                </span>
              </div>
              <div className="w-full bg-slate-600 rounded-full h-2" data-id="element-37">
                <div className={`h-2 rounded-full ${initiative.progress >= 0.8 ? 'bg-green-500' : initiative.progress >= 0.6 ? 'bg-yellow-500' : 'bg-red-500'}`} style={{
            width: `${initiative.progress * 100}%`
          }} data-id="element-38"></div>
              </div>
            </div>)}
        </div>}
    </div>;
};
export default CentralMap;